
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Table, Input, Typography, Space, Card, Button, Popconfirm } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import { useApi } from '../../helpers/apiClient';
import { DEFAULT_DATE_TIME_FORMAT, DEFAULT_PAGINATION, PAGE_SIZE_OPTIONS, SORT_TYPE } from '../../helpers/constants';
import { useNavigate } from 'react-router';

const { Title } = Typography;

function AdminList() {
    const navigate = useNavigate();

    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
    const [sortOn, setSortOn] = useState('createdAt');
    const [sortBy, setSortBy] = useState('desc');
    const [data, setData] = useState(null);

    const { callApi, loading } = useApi();

    // Fetch users from API
    // Debounce search input
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 3000);
        return () => clearTimeout(handler);
    }, [search]);

    useEffect(() => {
        const getUsers = async () => {
            const params = {
                search: debouncedSearch,
                sortOn: sortOn,
                sortBy: sortBy,
                skip: (pagination.page - 1) * pagination.pageSize,
                limit: pagination.pageSize,
            };
            const response = await callApi('get', '/admin/admins/', null, params);
            if (response) {
                const { users, total } = response.data;
                setPagination(prev => ({ ...prev, total }));
                setData(users);
            }
        }
        getUsers();
    }, [debouncedSearch, pagination.page, pagination.pageSize, sortOn, sortBy, callApi]);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'fullName',
            key: 'fullName',
            sorter: true,
            sortBy: sortOn === 'fullName' ? (sortBy === 'asc' ? 'ascend' : 'descend') : null,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            sortBy: sortOn === 'email' ? (sortBy === 'asc' ? 'ascend' : 'descend') : null,
        },
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            sortBy: sortOn === 'createdAt' ? (sortBy === 'asc' ? 'ascend' : 'descend') : null,
            defaultSortBy: sortOn === 'createdAt' ? (sortBy === 'asc' ? 'ascend' : 'descend') : undefined,
            render: (date) => date ? dayjs(date).format(DEFAULT_DATE_TIME_FORMAT) : '',
        },
        { title: 'Role', dataIndex: 'role', key: 'role' },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <>
                    {!record.isDeleted ? <Space>
                        <Popconfirm title="Are you sure to delete?" onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();

                        }} okText="Yes" cancelText="No">
                            <Button onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleDelete(record);
                            }} icon={<DeleteOutlined />} size="small" danger />
                        </Popconfirm>
                    </Space> : "Deleted"}
                </>
            ),
        },
    ];

    const handleDelete = (record) => {
      
    };

    const handleTableChange = (paginationTable, filters, sorter) => {
        if (paginationTable.current !== pagination.page || paginationTable.pageSize !== pagination.pageSize) {
            setPagination(prev => ({ ...prev, page: paginationTable.current, pageSize: paginationTable.pageSize }));
        }
        if (sorter && sorter.field) {
            setSortOn(sorter.field);
            setSortBy(sorter.order === 'ascend' ? SORT_TYPE.ASC : SORT_TYPE.DESC);
        }
    }



    // ...existing code...
    const handleRowClick = (record) => {
        // navigate(`/user/edit/${record._id}`);
        // console.log("Navigating to edit user:", record._id);
        // Replace with your navigation logic, e.g. using react-router
        // window.location.href = `/user/edit/${record._id}`;
    };

    return (
        <Card className="bg-white pb-4">
            <Space direction="vertical" className='w-full' size="large">
                <Title level={3} className="m-0">User List {pagination.total > 0 ? `(${pagination.total})` : ''}</Title>
                <Space className='w-full'>
                    <Input
                        placeholder="name or email"
                        prefix={<SearchOutlined />}
                        value={search}
                        onChange={e => {
                            setSearch(e.target.value);
                            setPagination(prev => ({ ...prev, page: 1 }));
                        }}
                        style={{ maxWidth: 240 }}
                        allowClear
                    />
                </Space>
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        current: pagination.page,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        showSizeChanger: true,
                        pageSizeOptions: PAGE_SIZE_OPTIONS,
                    }}
                    rowKey="_id"
                    onChange={handleTableChange}
                    onRow={record => ({
                        onClick: (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleRowClick(record);
                        }
                    })}
                />
            </Space>
        </Card>
    );
}

export default AdminList